import { BrowserRouter } from "react-router-dom";
import { useContext } from "react";
import UserRoutes from "../UserRoutes";
import PublicRoutes from "../PublicRoutes";
import AppLayout from "../../Components/AppLayout";
import { UserContext } from "../../App";

const AppRoutes = () => {
  const { userData } = useContext(UserContext);

  let effectiveRole = userData?.role;

  if (userData?.role === "user" && (!userData?.verified || !userData?.paid)) {
    effectiveRole = "public";
  }

  let routesComponent;

  switch (effectiveRole) {
    case "user":
      routesComponent = (
        <AppLayout>
          <UserRoutes />
        </AppLayout>
      );
      break;

    case "public":
    default:
      routesComponent = <PublicRoutes />;
      break;
  }

  return <BrowserRouter>{routesComponent}</BrowserRouter>;
};

export default AppRoutes;
